module.exports = __webpack_public_path__ + "img/cutting_fine_vacuum_packed.121fb8aa.png";